import { HausbankFieldTypes } from 'hausbank/inquiry/fields';

type HausbankTermsAndConditionsFieldTypes =
  HausbankFieldTypes['companyDataPage']['termsAndConditionsSection'];

export const mapHausbankTermsAndConditions = (values: HausbankTermsAndConditionsFieldTypes) => ({
  terms_and_conditions_accepted: values.termsAndConditionsAccepted && values.privacyPolicyAccepted,
});
